import { Lang, LanguageType } from 'types';

export const langMapper: Record<string, Lang> = {
    ru: Lang.Ru,
    en: Lang.En,
};

export const langMapperType: Record<string, LanguageType> = {
    ru: LanguageType.Russian,
    en: LanguageType.English,
};
